

import { CommonTriggerPointType } from '../Enum/CommonTriggerPointType';
import { ChildTriggerInfo, ChildValTriggerInfo } from './ChildTriggerInfo';
import { CommonOperation } from './CommonOperation';
import { ExecutingDataStatus } from './ExecutingDataStatus';

/**
* 校验规则定义
* @author chenyaobang<chenyaobang@inspur.com>
 */

export class CommonValidation extends CommonOperation {
    constructor() {
        super();
    }

    /**
     * 触发时变更集中需要包含的字段LabelID集合
     */
    public RequestElements: string[];

    public RequestChildElements: Map<string, string[]>;
    /**
     * Node状态触发时机的类型
     */
    public GetExecutingDataStatus: ExecutingDataStatus;

    public TriggerPointType: CommonTriggerPointType;

    /**
      * 子表触发条件
      */
    public ChildTriggerInfo: ChildValTriggerInfo[];
}
